import { Component, Input, OnInit, effect, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { finalize } from 'rxjs';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { ContentType } from '../../enum/content-type.enum';
import { TermsAndConditionService } from '../../../terms-and-conditions/service/terms-and-condition.service';
import { Content } from '../../models/content.type';
import { withCorrectedLanguages } from '../../utils/localized-content.util';

@Component({
  selector: 'taly-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  providers: [TermsAndConditionService],
  standalone: false,
})
export class TermsOfUseComponent implements OnInit {
  @Input() isPopup: boolean = false;

  transferSignal = inject(SharedSignalsService);
  private termsService = inject(TermsAndConditionService);
  private sanitizer = inject(DomSanitizer);

  textDirection!: string;

  content?: Content;
  isLoading = true;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {
    if (!this.isPopup) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    this.getTerms();
  }

  getTerms() {
    this.isLoading = true;

    this.termsService
      .getTermAndCondition(ContentType.TERMS_AND_CONDITION)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (resp) => {
          this.content = withCorrectedLanguages(resp);
        },
        error: (err) => {
          this.transferSignal.showMessage('error', err?.message || err);
        },
      });
  }

  sanitizerContent(htmlContent: any) {
    if (htmlContent) {
      return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    } else {
      return '';
    }
  }
}
